import { BlockActions } from '@modules/Nzo.CMS/Frontend/apps/web/cmsPage/blocks/shared/blockActions'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { BlockHeader } from '../shared/blockHeader'
import { CookiePlaceholder } from '@shared/Frontend/components/cookiePlaceholder'

export const IframeBlock: BlocksView['IframeBlock'] = (props) => {
  const { id, iframeTitle, link, acceptVideoCookie, videoCookieAccepted, trackingCookieAccepted, acceptTrackingCookie  } = props

  const { inView, ref } = useInView({ threshold: 0.1 })

  return (
    <section id={id} ref={ref} className={cn('block block--text block--iframe ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter">
        <BlockHeader {...props} />

        <div className="block__content">
          {(!videoCookieAccepted || !trackingCookieAccepted) ?
              <CookiePlaceholder 
                acceptCookie={() => {
                  acceptVideoCookie()
                  acceptTrackingCookie()
                }}
              />
            :
              <iframe 
                src={link} 
                title={iframeTitle}
                referrerPolicy='strict-origin-when-cross-origin'
              />
          }
        </div>

        <BlockActions {...props} datalayerCategory="text_block" />
      </div>
    </section>
  )
}
